import { useMemo } from 'react';

import { InputGroupV2, UniversalSelect } from '@equip.health/ui';

import {
  dropdownMenuOptionsMapper,
  getSelectedUniversalSelectOption,
} from '~/lib/util/inquiry.util';

import { DropdownBaseProps } from './types';
import { useGetProviderLanguagesEnumQuery } from '~/store/services/enumerations';

const LanguageDropdown = ({
  id,
  isInvalid = false,
  isRequired = false,
  onSelect,
  value,
}: DropdownBaseProps) => {
  const { data: languages } = useGetProviderLanguagesEnumQuery();
  const languageOptions = useMemo<UniversalSelectOption[]>(() => {
    return dropdownMenuOptionsMapper((languages || []).map((x) => x.code));
  }, [languages]);

  return (
    <InputGroupV2
      id={`${id}__language`}
      isRequired={isRequired}
      label="Preferred language"
    >
      <UniversalSelect
        id={`${id}__language`}
        isInvalid={isInvalid}
        isSearchable
        isSingleSelect
        onChange={(selected: UniversalSelectOption) =>
          onSelect(selected?.value)
        }
        options={languageOptions}
        value={getSelectedUniversalSelectOption(value, languageOptions)}
      />
    </InputGroupV2>
  );
};

export default LanguageDropdown;
